var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{class:{ 'input-container': true, 'right-aligned': _vm.alignRight },attrs:{"type":"text"},domProps:{"value":_vm.value},on:{"input":_vm.onInputChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }